var combineFunctions = function (a, b) { return function (v) { return b(a(v)); }; };
var pipe = function () {
    var transformers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        transformers[_i] = arguments[_i];
    }
    return transformers.reduce(combineFunctions);
};

export { pipe };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/node_modules/popmotion/dist/es/utils/pipe.js
// module id = 51
// module chunks = 0